//该文件用于创建Vuex中核心的store
//安装Vuex：npm i vuex@3   // vuex3版本对应vue2   vuex4版本对应vue3
//引用：import Vuex from "vuex";
//使用：Vue.use(Vuex)
//使用this.$store

//引入vue
import Vue from "vue";
//引入Vuex
import Vuex from 'vuex'

import baseinfo from './baseinfo'

import { getUserInfo } from '../requestapi/commRequest'

Vue.use(Vuex)

//准备actions，用于欧响应组件的动作
const actions = {
}

//准备mutations ，用于操作数据（state）
const mutations = {
    //获得用户信息
    GetUserInfoData(state) {
        getUserInfo().then(
            response => {
                console.log(response.data, 'getUserInfo');
                if (response.data.code === 10000) {
                    state.userinfo = response.data.data
                } else {
                    //未登录
                }
            },
            error => {
                console.log(error.response.data, 'getUserInfo error');
            }
        )
    }

}

//用于存储数据
const state = {
    companystring: '大洲文化传媒科技有限公司',
    userinfo: { person: { is_fire: false, is_nature: false, is_build: false, community: { classify: { code: '' }, }, } },
}



//创建store
const store = new Vuex.Store({
    actions: actions,
    mutations: mutations,
    state: state,
    modules: {
        baseinfo
    }
})

//暴露store
export default store

/*  使用说明


import {mapState, mapGetters,mapMutations,mapActions} from 'vuex'
computed:{
    //自己写读取state属性
    // sum(){
    //   return this.$store.state.sum
    // },

    //借助mapState生成属性，从state中读取数据（对象写法）
    // ...mapState({'sum':'sum', school:'stname'}),
    //借助mapState生成属性，从state中读取数据（数组写法）
    ...mapState(['sum','stname']),
    ...mapState('personAbout',['personList']),
}
 methods: {
    //自己写
    // increment(){
    //   // this.$store.dispatch('jia',this.n);
    //   this.$store.commit('JIA', this.n)
    // },
    // deincrement(){
    //   // this.$store.dispatch('jian',this.n);
    //   this.$store.commit('JIAN', this.n)
    // },

    //借助mapMutations生成属性，从mutations中读取函数（对象写法）
    ...mapMutations({'increment':'JIA', deincrement:'JIAN'}),
    //借助mapMutations生成属性，从mutations中读取函数（数组写法）
    // ...mapMutations(['JIA','JIAN']),

    //借助mapActions生成属性，从actions中读取函数（对象写法），注意参数，默认是event，需要将函数写为fun(n)
    ...mapActions({'incrementOdd':'jiaOdd', incrementWait:'jiaWait'}),
 }
*/